import React from 'react';
import { SELECTOR_STUDENT_SEARCH_NO_BORDER } from '../../../util/data-id';
import { SELECTOR_WIDTH } from '../../../util/vars';

type Props = {
  searchStudent: React.ReactNode;
  dateRangeSelector: React.ReactNode;
};

const Settings = ({ searchStudent, dateRangeSelector }: Props): JSX.Element => {
  return (
    <div className={'md:flex items-center justify-between'}>
      <div className={'md:flex items-center w-full md:w-2/4'}>
        <div data-id={SELECTOR_STUDENT_SEARCH_NO_BORDER} className={'w-full md:w-2/4 my-sm md:my-0'}>
          {searchStudent}
        </div>
      </div>
      <div style={{
        minWidth: SELECTOR_WIDTH,
      }}>{dateRangeSelector}</div>
    </div>
  );
};

Settings.displayName = 'Settings';

export default Settings;
